import styles from './HeaderText.module.scss';

import React, { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Collapse } from '@work4all/components/lib/components/collapse';
import { LockContext } from '@work4all/components/lib/hooks';
import { TextEditor } from '@work4all/components/lib/input/format-text/TextEditor';
import { LabeledInput } from '@work4all/components/lib/input/labeled-input';

import { remToPx } from '@work4all/data/lib/hooks/useRemToPx';

import { settings, useSetting } from '../../../../../../../../../../settings';

export const HeaderText: React.FC = () => {
  const { t } = useTranslation();

  const { control } = useFormContext();

  const rtfTextsInERP = useSetting(settings.rtfTextsInERP());

  const { locked } = useContext(LockContext);

  return (
    <Collapse defaultOpen title={t('MASK.HEADER_TEXT')} className={styles.root}>
      <Controller
        control={control}
        name={locked ? 'headerTextConverted' : 'rtfHeadText'}
        render={({ field }) => {
          const { value, onChange } = field;

          return rtfTextsInERP.value === true ? (
            <TextEditor
              key="rtfHeadText"
              value={value}
              config={{
                events: {
                  /**
                   * onBlur is used instead of onChange because due to modifying
                   * the shadowObject on every change the editor loses cursor position
                   */
                  blur: function () {
                    const newVal = this.html.get();
                    if (newVal !== value) {
                      onChange(newVal);
                    }
                  },
                },
              }}
              rtf
              enableTextBuildingBlocks
              disabled={locked}
              zIndex={10000}
              heightMax={remToPx(15)}
              applyZoomLevel={false}
            />
          ) : (
            <LabeledInput multiline {...field} />
          );
        }}
      />
    </Collapse>
  );
};
